import { useParams } from 'react-router-dom';
import  ReservoirStatistics  from "../mapcomponent/[id]/statistics"
import { EntReservoirHistoryFilter } from '../../../../models/filters/reservoirHistoryFilter';


const ReservoirStatisticsWrapper = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>Ошибка: ID не найден в URL</div>;
  }

  const filter = new EntReservoirHistoryFilter();
  filter.reservoirId = Number(id);

  return <ReservoirStatistics filter={filter} />;
};

export default ReservoirStatisticsWrapper;
